import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { components } from 'react-select';
import { withRouter } from 'react-router';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import popQueryString from 'rebook/apps/utils/urls/popQueryString';
import { FILTER_BY_SUBSCRIPTION } from 'rebook/apps/base/constants';
import Select from 'rebook/apps/base/components/Select';
import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';

import styles from './style.scss';


const SubscriptionOption = (props) => {
  return (
    <components.Option {...props}>
      <div className={styles.optionTextContainer}>
        <span>{props.children}</span>
        {props.data.type &&
          <SubscriptionIcon width={24} height={24} type={props.data.type} extraClassName={styles.optionIcon} />}
      </div>
    </components.Option>
  );
};

const SubscriptionValueContainer = (props) => {
  const type = get(props, 'selectProps.value.type', null);
  return (
    <div className={styles.valueTextContainer}>
      {type
        ? (
          <div className={styles[`valueText${type}`]}>
            <components.ValueContainer {...props} />
          </div>
        )
        : <components.ValueContainer {...props} />
      }
      {type && <SubscriptionIcon width={24} height={24} type={type} />}
    </div>
  );
};


class FilterBySubscriptionType extends React.Component {
  onChange(subscriptionId) {
    if (subscriptionId.value !== null) {
      let newQueryString = fixQueryString(
        get(this, 'props.location.search', ''), { s: subscriptionId.value }
      );
      newQueryString = popQueryString(newQueryString, ['page']);
      this.props.history.push({
        search: newQueryString,
      });
    }
    else {
      this.props.history.push({
        search: popQueryString(get(this, 'props.location.search', ''), ['s', 'page']),
      });
    }
    this.props.onChange(subscriptionId.value);
  }

  render() {
    const value = FILTER_BY_SUBSCRIPTION.find((item) => String(item.value).includes(this.props.subscriptionId));
    return (
      <Select name="subscription"
        extraClassName={this.props.extraClassName}
        options={FILTER_BY_SUBSCRIPTION}
        value={value}
        width={this.props.width}
        onChange={(value) => this.onChange(value)}
        isDisabled={this.props.isDisabled}
        components={{
          Option: SubscriptionOption,
          ValueContainer: SubscriptionValueContainer,
        }} />
    );
  }
}

FilterBySubscriptionType.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  width: PropTypes.number,
};

FilterBySubscriptionType.defaultProps = {
  isDisabled: false,
  width: 200,
  onChange: function() {},
};

export default withRouter(FilterBySubscriptionType);
